import logBase from '../utils/logger'
import { loadScript } from '../utils/utils'
import { BIDDERS_TIMEOUT } from '../constants'
import { BannersConfigWithDefault } from '../configs/game-configs'
import { buildPrebidPartnersBids, partnersConfig } from './partners/config'

const log = logBase.extend('PREBID')

export const initPrebid = (generalConfig: BannersConfigWithDefault) => {
  log('Prebid is loading...')
  // @ts-expect-error 'import.meta' is handled by babel
  const prebidSourceScript = new URL('prebid-script.min.js', import.meta.url).toString()

  return loadScript(prebidSourceScript).then(() => {
    const { adUnits, config, bidderSettings } = buildAdUnits(generalConfig)

    window.pbjs = window.pbjs || {}
    window.pbjs.que = window.pbjs.que || []

    window.pbjs.que.push(() => {
      window.pbjs.addAdUnits(adUnits)
      window.pbjs.setConfig(config)
      window.pbjs.bidderSettings = bidderSettings
      log('Prebid initiated')
    })
  })
}

// Using advanced size mapping prebid module
const buildResponsiveSizeConfig = (sizeMap: BannersConfigWithDefault['adSlotSettings'][0]['sizeMap']) => {
  const sizeConfig = []

  for (const [viewportSize, slotSize] of [...sizeMap].reverse()) {
    sizeConfig.push({
      minViewPort: viewportSize,
      sizes: slotSize,
    })
  }

  return sizeConfig
}

const buildAdUnits = ({ adSlotSettings }: BannersConfigWithDefault) => {
  const adUnits = []
  const { config, bidderSettings } = partnersConfig

  for (const { sizeMap, unitPath } of adSlotSettings) {
    const sizeConfig = buildResponsiveSizeConfig(sizeMap)

    const { bids } = buildPrebidPartnersBids(unitPath)

    adUnits.push({
      code: unitPath, // Must match Google Ad Manager slot name
      bids,
      mediaTypes: {
        banner: {
          sizeConfig,
        },
      },
    })
  }

  const response = {
    config: {
      bidderTimeout: BIDDERS_TIMEOUT,
      ...config,
    },
    adUnits,
    bidderSettings,
  }

  return response
}

export const INTERNAL = {
  buildAdUnits,
  buildResponsiveSizeConfig,
}
